export class FileHeaderMappingModel {
    public schemaHeader: string = null as unknown as string;
    public fileHeader: string = null as unknown as string;

    public constructor({schemaHeader, fileHeader}: {schemaHeader: string, fileHeader: string}) {
        this.fileHeader = fileHeader;
        this.schemaHeader = schemaHeader;
    }
}